import React from "react";

import { PatientCard } from "features/patients/components/PatientCard/PatientCard";

import styles from "./SimplePatientPageLayout.module.css";

const SimplePatientPageLayout = ({ children, sidebar }) => {
  return (
    <div className={styles.layout}>
      <div className={styles.firstColumn}>
        <PatientCard />
        {sidebar}
      </div>
      <div className={styles.secondColumn}>{children}</div>
    </div>
  );
};

export { SimplePatientPageLayout };
